// @ts-check
import { enumLabel } from "./format.js";

/**
 * I18N-02: one vocabulary for the states the server reports, so no screen shows
 * a raw identifier. Unknown values fall back to sentence case (enumLabel).
 */
export const labels = {
  workState: {
    backlog: "Backlog",
    ready: "Ready",
    in_progress: "In progress",
    review: "Review",
    done: "Done",
    cancelled: "Cancelled",
  },
  runStatus: {
    admitted: "Queued",
    running: "Running",
    completed: "Finished",
    error: "Failed",
    cancelled: "Stopped",
    unknown: "Outcome unknown",
    frozen: "Frozen for review",
    applied: "Applied",
    review: "In review",
    reviewing: "In review",
    rejected: "Rejected",
    pending: "Pending",
    proposed: "Proposed",
  },
  review: {
    approved: "Approved",
    changes_requested: "Changes requested",
    rejected: "Rejected",
    pending: "Pending",
    passed: "Passed",
    failed: "Failed",
  },
  attentionStatus: {
    awaiting_approval: "Waiting for approval",
    waiting_approval: "Waiting for approval",
    waiting: "Waiting for you",
    blocked: "Blocked",
    failed: "Failed",
    review: "Needs review",
    ready_for_review: "Ready for review",
    needs_input: "Needs your input",
  },
  workEvent: {
    created: "Created",
    updated: "Edited",
    transitioned: "Moved",
    state_changed: "Moved",
    commented: "Commented",
    assigned: "Assigned",
    executed: "Started",
    execution_started: "Started",
    execution_completed: "Finished",
    completion_reported: "Reported done",
    completion_accepted: "Accepted",
    waiting: "Started waiting",
    wait_ended: "Stopped waiting",
    workspace_released: "Workspace released",
    pull_request_opened: "Pull request opened",
    pull_request_updated: "Pull request updated",
    pull_request_merged: "Pull request merged",
    pull_request_closed: "Pull request closed",
    pull_request_merged_done: "Done: pull request merged",
    pull_request_fix_started: "Asked a bunny to fix",
    build_started: "Build it started",
    build_step: "Build step finished",
    build_resumed: "Build resumed",
    build_done: "Build finished",
    build_stopped: "Build stopped",
    build_failed: "Build failed",
  },
  platform: {
    telegram: "Telegram",
    slack: "Slack",
    discord: "Discord",
    matrix: "Matrix",
    email: "Email",
  },
  receiveMode: {
    webhook: "Webhook",
    polling: "Long polling",
    socket: "Socket Mode",
    gateway: "Gateway",
    sync: "Sync",
  },
  receiver: {
    stopped: "Stopped",
    connecting: "Connecting",
    connected: "Connected",
    backoff: "Retrying",
    failed: "Failed",
  },
  notification: {
    monitor_unhealthy: "Monitor unhealthy",
    monitor_recovered: "Monitor recovered",
    credential_expiring: "Credential expiring",
    automation_failed: "Automation failed",
    message_failed: "Message failed",
  },
};

/** @param {keyof typeof labels} vocabulary @param {string} value */
export const label = (vocabulary, value) =>
  enumLabel(labels[vocabulary], value);
